import { clsx } from "clsx";

import * as styles from "./styles.module.scss";

interface ParagraphWithBoldPartsProps {
  className?: string;
  content: string;
}

/**
 * The component accepts a `content` string and renders text wrapped in **asterisks** in bold
 */
const ParagraphWithBoldParts = ({ className, content }: ParagraphWithBoldPartsProps) => {
  const contentParts = content.split(/(\*\*.*?\*\*)/g);

  return (
    <p className={clsx(styles.container, className)}>
      {contentParts.map((part, index) =>
        part.startsWith("**") && part.endsWith("**") ?
          <b key={index}>{part.slice(2, -2)}</b>
        : part,
      )}
    </p>
  );
};

export default ParagraphWithBoldParts;
